import React from "react";
import bg from "assests/services/bg.jpg";
const Hero = () => {
  return (
    <section
      style={{ backgroundImage: `url(${bg})` }}
      className=" bg-cover bg-center py-44 normal-section-80 flex flex-col items-center justify-center"
    >
      <h1 className="text-2xl sm:text-3xl text-white mb-4 uppercase  text-gray-400">
        Our Services
      </h1>

      <p className="text-4xl sm:text-5xl lg:text-7xl text-white text-center bebas capitalize mb-[6rem]">
        Innovation, Quality, and Reliability
      </p>
    </section>
  );
};

export default Hero;
